import React from "react";
import { Helmet } from "react-helmet";
import { useQuery } from "@apollo/react-hooks";
import { appName } from "../../app.json";
import { DASHBOARD } from "../../queries/appointment.query";
import LoadingSpinner from "../../partials/loading";
import { Doughnut } from "react-chartjs-2";
import FabButton from "../../partials/Buttons/FabButton";
import AuthProvider from "../../providers/Auth.Provider";
import { EventEmitter } from "../../event/EventEmitter";
import { EVENT_TARGET } from "../../event/model";
import { toast } from "react-toastify";
import { CleanMessage } from "../../util/app";

const AppointmentDashboard = () => {
    const { loading, refetch, data } = useQuery(DASHBOARD, {
        notifyOnNetworkStatusChange: true,
        onError: (e) => toast.error(CleanMessage(e.message)),
    });
    const { admin, topStaff } = AuthProvider.authProvider.GetAuthenticatedStaff();

    const title = "Dashboard";

    EventEmitter.subscribe(EVENT_TARGET.APPOINTMENT, () => refetch());
    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>
            <h2>{title}</h2>
            {loading && <LoadingSpinner loading={loading} bar={true} />}
            {!loading && data && (
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <div className="row">
                        <div className="col-lg-4 col-sm-6">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="info-box bg-purple">
                                        <span className="info-box-icon push-bottom bg-transprnt">
                                            <i className="material-icons">calendar_view_day</i>
                                        </span>
                                        <div className="info-box-content m-b-10">
                                            <span className="info-box-text">All Appointment</span>
                                            <span className="info-box-number">{data.TotalAppointments}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-sm-12 fade-in">
                                    <div className="info-box bg-success">
                                        <span className="info-box-icon push-bottom bg-transprnt">
                                            <i className="material-icons">calendar_today</i>
                                        </span>
                                        <div className="info-box-content m-b-10">
                                            <span className="info-box-text">Active Appointment</span>
                                            <span className="info-box-number">{data.ActiveAppointmentCount}</span>
                                            {/* <span className="progress-description">
											Total active Appointment
										</span> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-sm-6 fade-in">
                            <Doughnut
                                width={50}
                                height={50}
                                data={{
                                    datasets: [
                                        {
                                            data: data.AppointmentAttendanceRatio.map((i) => i.count),
                                            backgroundColor: ["#28a745", "#17a2b8", "#E67D21", "#28a745"],
                                        },
                                    ],
                                    labels: data.AppointmentAttendanceRatio.map((i) => (i.attended ? "Attended" : "Unattended")),
                                }}
                                options={{
                                    animation: {
                                        animateScale: true,
                                    },
                                    maintainAspectRatio: true,
                                    cutoutPercentage: 60,
                                }}
                            />
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="row">
                                {data.AppointmentAttendanceRatio.map((x, o) => (
                                    <div key={o} className="col-md-12 fade-in">
                                        <div className="info-box bg-white">
                                            <span className={`info-box-icon push-bottom ${x.attended ? "bg-success" : "bg-info"}`}>
                                                <i className="material-icons">bubble_chart</i>
                                            </span>
                                            <div className="info-box-content m-b-10">
                                                <span className="info-box-text">{x.attended ? "Attended" : "Unattended"} Attendance</span>
                                                <span className="info-box-number">{x.count}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {(admin || topStaff) && <FabButton title="New Appointment" onClick={() => {}} />}
        </>
    );
};
export default AppointmentDashboard;
